<template>
  <!-- todo(TECH-325): add navigation (back...) -->
  <case-service-log :case-id="$route.params.caseId"/>
</template>

<script>
    import CaseServiceLog from '../../components/Sales/case/CaseServiceLog'

    export default {
        name: 'case-services-page',
        components: {
            CaseServiceLog
        },
        props: {},
        data() {
            return {}
        },
        computed: {},
        mounted() {

        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/pages/cases/CaseServicesPage.vue